/**
 * phase2RailGeometry.ts
 * Shared column geometry for the Phase-2 employee-planning "time rail" (2026-06-23).
 *
 * The Task Weekly Schedule (Phase2WeeklyGrid) and the Employee Weekly Capacity
 * (Phase2CapacityTable) are stacked and must line up WEEK-for-WEEK. They used to
 * size their columns independently (task week 460 vs capacity 7×68=476, gutters
 * 200 vs 280), so the weeks never aligned. Both now derive from THESE tokens:
 *
 *   gutter (left label column) = RAIL_GUTTER_W   (task: Task col; capacity: Employee+Role)
 *   per-week width             = RAIL_WEEK_W = RAIL_DAY_W × 7
 *
 * Keep capacity's EMP_COL_W + ROLE_COL_W === RAIL_GUTTER_W and its DAY_W === RAIL_DAY_W.
 */

/** Left label column total width (task name / employee+role). */
export const RAIL_GUTTER_W = 280;

/** One day column in the capacity grid. */
export const RAIL_DAY_W = 68;

/** One week column — task grid uses it directly; capacity = 7 × day. */
export const RAIL_WEEK_W = RAIL_DAY_W * 7;
